/**
 * Admin API calls.
 */

import { get, post, put, del } from '../../services/apiClient';

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();
    Object.keys(params).forEach((key) => {
        if (params[key]) query.append(key, params[key]);
    });
    const queryString = query.toString();
    return queryString ? `?${queryString}` : '';
};

const api = {
    login: (username, password) =>
        post('/api/admin/login', { username, password }, { token: null }),

    getProfile: (token) => get('/api/admin/profile', { token }),

    changePassword: (token, currentPassword, newPassword) =>
        put('/api/admin/change-password', { currentPassword, newPassword }, { token }),

    // Product APIs
    getProducts: (params = {}) => get(`/api/admin/products${buildQuery(params)}`),

    getProduct: (id) => get(`/api/admin/products/${id}`),

    createProduct: (productData) => post('/api/admin/products', productData),

    updateProduct: (id, productData) => put(`/api/admin/products/${id}`, productData),

    deleteProduct: (id) => del(`/api/admin/products/${id}`),

    permanentDeleteProduct: (id) => del(`/api/admin/products/${id}/permanent`)
};

export default api;
